/**
 * Main.js
 *
 * @since 1.0.0
 */

import "objectFitPolyfill";
import objectFitImages from "object-fit-images";
import ObserveFontFace from "./modules/ObserveFontFace";
import FormValidation from "./modules/FormValidation";
import SendForm from "./modules/SendForm";
import StepsForm from "./modules/StepsForm";
import PhoneLink from "./modules/PhoneLink";
import NavDropdown from "./modules/NavDropdown";
import MobileHeader from "./modules/MobileHeader";
import Hero from "./modules/Hero";
import LazyLoadBackground from "./modules/LazyLoadBackground";
import ProjectsSlider from "./modules/ProjectsSlider";
import Maps from "./modules/Maps";
import ScrollMonitor from "./modules/ScrollMonitor";
import CheckFlyerCheckbox from "./modules/CheckFlyerCheckbox";
// import PrefillForm from './modules/PrefillForm'
import CallMeBackPopup from "./modules/CallMeBackPopup";
import LazyLoad from "./modules/LazyLoad";
import StickyShare from "./modules/StickyShare";
import UploadButton from "./modules/UploadButton";
import RentPopup from "./modules/RentPopup";
import Modal from "./modules/Modal";
import AnimatedVan from "./modules/AnimatedVan";
import StickyHeader from "./modules/StickyHeader";
import Lightbox from "./modules/Lightbox";
import VideoFacade from "./modules/VideoFacade";

(function IIFE() {
    ObserveFontFace();
    FormValidation();
    SendForm();
    StepsForm();
    objectFitImages();
    PhoneLink();
    NavDropdown();
    MobileHeader();
    Hero();
    LazyLoadBackground();
    ProjectsSlider();
    Maps();
    ScrollMonitor();
    CheckFlyerCheckbox();
    // PrefillForm()
    CallMeBackPopup();
    RentPopup();
    LazyLoad();
    StickyShare();
    UploadButton();
    Modal();
    AnimatedVan();
    StickyHeader();
    Lightbox();
    VideoFacade();
})();

// WEBPACK FOOTER //
// ./src/js/main.js
